import styled, { css } from 'styled-components';
import { MenuItem as MuiMenuItem, Select as MuiSelect } from '@mui/material';
import { IMenuItemStyle, ISelectStyle } from './types';

export const Select = styled(MuiSelect)<ISelectStyle>`
  font-size: 14px;
  border-radius: ${({ borderRadius }) => borderRadius};
  padding: 4px;
  margin: 0;
  background-color: ${({ backgroundColor }) => backgroundColor || '#fff'};
  box-shadow: none;
  color: #2e7d32;
  font-weight: 600;
  height: 100%;

  width: ${({ width }) => width};

  ${({ errorMessage }) => {
    if (errorMessage) {
      return css`
        border: 1.4px solid #f44336;
        & .MuiSelect-select {
          color: #f44336;
        }
      `;
    }
  }}
  & .MuiSelect-select {
    padding: 8px 12px;
    border-radius: ${({ borderRadius }) => borderRadius};
  }

  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;

export const MenuItem = styled(MuiMenuItem)<IMenuItemStyle>`
  margin: 0;
  background: #fff !important;
  font-size: 16px;
  color: #1c4d1e;
  width: ${({ width }) => width || '100%'};

  word-wrap: break-word;
  flex-wrap: wrap;

  padding: 10px 20px;
  margin: 0;
  flex-wrap: wrap;
  align-items: center;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ pair }) => {
    if (pair) {
      return css`
        background: rgb(237, 255, 238) !important;
      `;
    }
  }}
  &:hover {
    background: #ececec !important;
    font-weight: 500;
  }

  &.Mui-selected {
    background: #94ee98 !important;
    font-weight: 700;
    color: #1c4d1e !important;
    font-size: 16px;
    display: none;
  }
`;
